import { createSlice } from '@reduxjs/toolkit';
import { IMapAllocationView } from '../types';

const initialState: IMapAllocationView = {
  data: {
    agents: [],
    casesMapLocations: []
  },
  reportingAgencies: [],
  agencyTls: [],
  isAccordionExpanded: true,
  selectedPin: '',
  unAllocatedCaseFlag: false,
  isLoading: false
};

const caseAllocationSlice = createSlice({
  name: 'caseAllocation',
  initialState,
  reducers: {
    setCasesAllocationData: (state, action) => {
      state.data = action.payload;
    },
    setTlOptions: (state, action) => {
      state.agencyTls = action.payload;
    },
    setReportingAgencies: (state, action) => {
      state.reportingAgencies = action.payload;
    },
    setIsAccordionExpanded: (state, action) => {
      state.isAccordionExpanded = action.payload;
    },
    setCasesAllocationLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setSelectedPin: (state, action) => {
      if (state.selectedPin === action.payload) {
        state.selectedPin = '';
        return;
      }
      state.selectedPin = action.payload;
    },
    setUnAllocatedCaseFlag: (state, action) => {
      state.unAllocatedCaseFlag = action.payload;
    }
  }
});

export const {
  setCasesAllocationData,
  setTlOptions,
  setIsAccordionExpanded,
  setCasesAllocationLoading,
  setSelectedPin,
  setReportingAgencies,
  setUnAllocatedCaseFlag
} = caseAllocationSlice.actions;

export default caseAllocationSlice.reducer;
